module.exports = __webpack_public_path__ + "img/2024big16.f6c7291d.png";